module.exports = __webpack_public_path__ + "img/barricas_3.fb724dbb.jpeg";